import React from "react";
import styled from "styled-components";

import { Recommendation } from "../../service/areena-recommendations";
import { recommendationTextColor } from "../../styles/variables";
import { RecommendationCard } from "../recommendations/RecommendationCard";
import {
  BackgroundGradient,
  RecommendationBackground,
  RecommendationCardTitle,
  RecommendationItemBackground,
  RecommendationList,
  smallHeaderFont,
  watchNext
} from "../recommendations/RecommendationStyles";
import { CommonCardProps } from "../recommendations/recommendationTypes";

const RecommendationListContainer = styled.div`
  margin: 0 0 60px;
  position: absolute;
  width: 100%;
`;

const SmallUiRecommendationList = styled(RecommendationList)`
  flex-wrap: nowrap;
  margin: 0 20px;
  overflow-x: auto;
`;

const Absolute = styled.div`
  position: absolute;
  width: 100%;
`;

const RecommendationsHeader = styled(RecommendationCardTitle)<{
  newPlayerUi: boolean;
}>`
  &&& {
    color: ${recommendationTextColor};
    margin: ${props => (props.newPlayerUi ? "46px 20px; 0.3em" : "0.3em 20px;")}
      ${smallHeaderFont};
  }
`;

export const SmallEndRecommendations = ({
  commonCardProps,
  recommendations
}: {
  recommendations: Recommendation[];
  commonCardProps: CommonCardProps;
}) => (
  <RecommendationBackground>
    <Absolute>
      <RecommendationItemBackground image={recommendations[0].image} />
    </Absolute>
    <BackgroundGradient />
    <RecommendationsHeader newPlayerUi={commonCardProps.newPlayerUi}>
      {watchNext(commonCardProps.language)}
    </RecommendationsHeader>
    <RecommendationListContainer>
      <SmallUiRecommendationList>
        {recommendations.map((recommendation, index) => (
          <RecommendationCard
            key={`end-small-recommendation-${index}`}
            {...{
              ...commonCardProps,
              index,
              recommendation
            }}
          />
        ))}
      </SmallUiRecommendationList>
    </RecommendationListContainer>
  </RecommendationBackground>
);
